import { createFileRoute } from "@tanstack/react-router";
import { ProductAdminManager } from "@/components/admin/product-manager";

export const Route = createFileRoute("/_authenticated/admin/services")({
  component: () => <ProductAdminManager kind="service" />,
});
